export const bannerType = [
  { key: "Mobile", value: "1" },
  { key: "Desktop", value: "2" },
];
export const showBannerEnum = [
  { key: "Top slider", value: "1" },
  { key: "Middle", value: "2" },
  { key: "Lower", value: "3" },
];

export const finishingEnum = [
  "White Rhodium Silver",
  "14K Rose Gold Overlay",
  "14K Yellow Gold Overlay",
  "14K Solid Rose Gold",
  "14K Solid Yellow Gold",
  "14K Solid White Gold",
];

export const ORDER_STATUSES = ["Pending", "Processing", "Shipping", "Delivered", "Cancelled", "Refunded"];
export const orderStatusLabel = { Pending: "New", Processing: "Processing", Shipping: "Shipped", Delivered: "Delivered", Cancelled: "Cancelled", Refunded: "Refunded" };
export const PAID = ["Verified", "PartiallyRefunded", "Refunded"];
export const paymentLabel = {
  Verified: "Paid",
  Pending: "Awaiting payment",
  Failed: "Failed",
  Cancelled: "Cancelled",
  Expired: "Expired",
  Refunded: "Refunded",
  PartiallyRefunded: "Partly refunded",
};
export const paymentTone = { Verified: "ok", Pending: "warn", Failed: "bad", Cancelled: "", Expired: "", Refunded: "info", PartiallyRefunded: "info" };
export const orderTone = { Pending: "warn", Processing: "info", Shipping: "info", Delivered: "ok", Cancelled: "", Refunded: "" };

export const socialMediaEnum = [
  { key: "Facebook", value: "bi bi-facebook" },
  { key: "Instagram", value: "bi bi-instagram" },
  { key: "X / Twitter", value: "bi bi-twitter-x" },
  { key: "YouTube", value: "bi bi-youtube" },
  { key: "Pinterest", value: "bi bi-pinterest" },
  { key: "TikTok", value: "bi bi-tiktok" },
  { key: "LinkedIn", value: "bi bi-linkedin" },
  { key: "WhatsApp", value: "bi bi-whatsapp" },
];
